import React from "react";

import Interweave from "interweave";

import styles from "./CityAboutComponent.module.css";

export default function CityAboutComponent(props) {
  const { aboutCity } = props;
  return (
    <div className={`mt-5 ${styles.aboutCity_section}`}>
      {aboutCity &&
        aboutCity.map((city, index) =>
          (index + 1) % 2 !== 0 ? (
            <React.Fragment key={index}>
              <div className={`d-flex ${styles.aboutCity_container}`}>
                <div style={{ flex: "1" }}>
                  <div
                    className={styles.city_image_container}
                   
                  >
                    <img
                      src={process.env.IMAGE_LINK + city.image}
                      alt=""
                      className={styles.aboutCityImage}
                      width={490}
                      height={560}
                    />
                  </div>
                </div>
                <div
                  style={{ flex: "1", marginLeft: "52px", marginRight: "52px",display:"flex",alignItems:"center" }}
                >
                  <div>
                  <h2 className={styles.aboutCityTitle}>{city.title}</h2>
                  <p className={styles.aboutCityContent}>
                    <Interweave
                      allowElements={false}
                      content={city.content}
                    />
                  </p>
                  </div>
                </div>
              </div>
            </React.Fragment>
          ) : (
            <React.Fragment key={index}>
              <div className={`d-flex ${styles.aboutCity_container}`}>
                <div
                  style={{
                    flex: "1",
                    paddingLeft: "64px",
                    paddingTop: "64px",
                    marginRight: "52px",
                  }}
                >
                  <h2 className={styles.aboutCityTitle}>{city.title}</h2>
                  <div className={styles.aboutCityContent}>
                    <Interweave
                      allowElements={false}
                      content={city.content}
                    />
                  </div>
                </div>
                <div style={{ flex: "1", paddingTop: "64px" }}>
                  <div className={styles.city_image_container}>
                    <img
                      src={process.env.IMAGE_LINK + city.image}
                      alt=""
                      className={styles.aboutCityImage}
                      width={490}
                      height={560}
                    />
                  </div>
                </div>
              </div>
            </React.Fragment>
          )
        )}
    </div>
  );
}
